export enum UserPermissionEnum
{
    Normal = 1,
    Admin = 2
}